<template>
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.1667 3.41667V5.25C17.1667 5.91667 16.7501 6.75 16.3334 7.16667L12.7501 10.3333C12.2501 10.75 11.9167 11.5833 11.9167 12.25V15.8333C11.9167 16.3333 11.5834 17 11.1667 17.25L10.0001 18C8.91673 18.6667 7.41673 17.9167 7.41673 16.5833V12.1667C7.41673 11.5833 7.0834 10.8333 6.75007 10.4167L6.3584 10.0083C6.10007 9.73333 6.05007 9.31667 6.2584 8.99167L10.5251 2.14167C10.6751 1.9 10.9417 1.75 11.2334 1.75H15.5001C16.4167 1.75 17.1667 2.5 17.1667 3.41667Z"
      fill="#4F4F51"
    />
    <path
      d="M8.62516 3.025L5.66683 7.76667C5.3835 8.225 4.7335 8.29167 4.3585 7.9L3.5835 7.08333C3.16683 6.66667 2.8335 5.91667 2.8335 5.41667V3.5C2.8335 2.5 3.5835 1.75 4.50016 1.75H7.91683C8.56683 1.75 8.96683 2.46667 8.62516 3.025Z"
      fill="#4F4F51"
    />
  </svg>
</template>

<script>
export default {};
</script>

<style>
</style>